
// 在需要的地方引入即可import http from 'http.js'
import axios from 'axios'; // 引入axios
import QS from "qs"
// 基地址
axios.defaults.baseURL = 'https://api.cjkt.com'
// 设置默认的请求超时时间
axios.defaults.timeout = 10000;
// post请求头的设置
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 添加请求拦截器
axios.interceptors.request.use(config => {        
    // const token = store.state.token;        
    // token && (config.headers.Authorization = token);        
    return config;    
},    
error => {        
    return Promise.error(error);    
})
  // 添加响应拦截器
axios.interceptors.response.use(response => {
    // 对响应数据做点什么
    return response;
},
error => {
    // 对响应错误做点什么
    return Promise.reject(error);
});

// get方法，对应get请求
export function get(url, params){    
    return new Promise((resolve, reject) =>{        
        axios.get(url, {
            params: params        
        }).then(res => {
            resolve(res.data);
        }).catch(err =>{
            reject(err.data)        
    })    
});}
// post方法，对应post请求
export function post(url, params) {
    return new Promise((resolve, reject) => {
         axios.post(url, QS.stringify(params))
        .then(res => {
            resolve(res.data);
        })
        .catch(err =>{
            reject(err.data)
        })
    });
}